export default __webpack_public_path__ + "static/media/commision-report.86ce3121.svg";